import React from 'react'
import TagV2 from './TagV2'

import { initialState, tagReducer, Actions } from './reducer'
import { useUserAPI } from '../../../../providers/UserAPIProvider'
import { useIsVerticalOverflow } from '../../../../hooks/useIsVerticalOverflow'
import TagInputV2 from '../../TagInputv2'
import ShowMoreLess from '../../../atoms/ShowMoreLess'

import useStyles from './styles'

const TagBlockV2 = ({ user }) => {
  const { uploadUser } = useUserAPI()
  const [expanded, setExpanded] = React.useState(false)
  const [state, dispatch] = React.useReducer(tagReducer, initialState)
  const [lastID, setLastID] = React.useState('')
  const userID = React.useMemo(() => user?.id || null, [user])
  const ref = React.useRef()
  const isOverflow = useIsVerticalOverflow(ref, state.tags, expanded, 62)
  const classes = useStyles({ expanded })

  // Save to cache
  React.useEffect(() => {
    dispatch({ type: Actions.SAVE, userID })
  }, [userID, state.tags, state.tag, state.startingTag, state.changed])

  // Restore from cache
  React.useEffect(() => {
    if (userID) {
      dispatch({ type: Actions.LOAD, userID })
    }
  }, [userID])

  // Pull tags from user
  React.useEffect(() => {
    if (!userID || userID === lastID) {
      return
    }

    dispatch({ type: Actions.SET_TAGS, tags: user.tags || [] })
    setLastID(userID)
  }, [userID, lastID, user])

  // Upload tags
  React.useEffect(() => {
    if (!user || !state.changed) {
      return
    }

    uploadUser({ ...user, tags: state.tags }, false, () =>
      dispatch({ type: Actions.UPLOAD_DONE })
    )
  }, [state.changed, state.tags, uploadUser, user])

  //reset expanded on userid change
  React.useEffect(() => {
    setExpanded(false)
  }, [userID])

  const submitTag = tag => {
    dispatch({ type: Actions.ADD, tag })
  }

  const handleDelete = tag => () => {
    dispatch({ type: Actions.DELETE, tag })
  }

  return (
    <React.Fragment>
      <div className={classes.root}>
        <div className={classes.tagInputContainer}>
          <TagInputV2
            height={24}
            inputClass={classes.inputClass}
            handleAddTag={submitTag}
            alwaysShowInput
            noAutofocus
            customPlaceholder
            onResetValueTrigger={userID}
          />
        </div>

        <div className={classes.tagList} ref={ref} aria-expanded={expanded}>
          {state.tags.map((tag, i) =>
            tag === state.startingTag ? null : (
              <TagV2 key={i} tag={tag} onDelete={handleDelete(tag)} />
            )
          )}
        </div>
        {isOverflow && (
          <ShowMoreLess expanded={expanded} setExpanded={setExpanded} />
        )}
      </div>
    </React.Fragment>
  )
}

export default TagBlockV2
